import * as React from 'react';
import Button from '../_common/button';
import { cn, getText, getConfig } from '../../helpers';

import DatasetTile from '../tile/dataset-tile';
import SolutionTile from '../tile/solution-tile';
import BlueprintTile from '../tile/blueprint-tile';

const dataTileDefaults = getConfig('components.tile-grid');
const showAll = getText('generic.showAll');

function getIntialLoad() {
    const { breakPoints } = dataTileDefaults;
    const width = window.innerWidth;
    let numberOfTiles = breakPoints[0].value;
    for (let i = 0; i < breakPoints.length; i++) {
        if (breakPoints[i].minWidth > width) break;
        numberOfTiles = breakPoints[i].value;
    }
    return numberOfTiles;
}

export default class TileGrid extends React.Component<TileGridProps, TileGridState> {
    private constructor(props: TileGridProps) {
        super(props);
        const { list } = this.props;
        this.state = {
            show: getIntialLoad(),
            total: list.length,
            update: false
        };
        this.handleAddMore = this.handleAddMore.bind(this);
    }

    static getDerivedStateFromProps(props: TileGridProps, state: TileGridState) {
        if (state.update) {
            return {
                show: state.show,
                update: false
            };
        }
        return {
            show: getIntialLoad(),
            total: props.list.length,
            update: false
        };
    }

    private handleAddMore(event: React.SyntheticEvent) {
        event.preventDefault();
        this.setState((prevState: TileGridState) => {
            return {
                show: prevState.show + dataTileDefaults.additionalLoad,
                update: true
            };
        });
    }

    public render() {
        const { show, total } = this.state;
        const { list, loading } = this.props;
        const maxShow = show > total ? total : show;
        return (
            <section className="page-section">
                <div className={cn('tile-grid', 'page-section__inner', { 'tile-grid--loading': loading })}>
                    {/* <p>{`Showing ${maxShow} of ${total}`}</p> */}
                    <div className="tile-grid__wrapper">
                        {list.slice(0, show).map((item: DataProfileCard | APISolution | APIBlueprint) => {
                            if ('MktplaceSolutionName' in item) {
                                return <SolutionTile key={item.KeyPlatformService} solution={item} />;
                            } if ('KeyMarketplaceBlueprint' in item) {
                                const card = item as APIBlueprint;
                                return <BlueprintTile key={card.KeyMarketplaceBlueprint} dataProfile={card} />;
                            }
                            return (
                                <DatasetTile key={item.id + item.name} dataProfile={item} /> // appended name in id to handle conflict between bundle and dataset
                            );
                        })}
                        {/* list of dummy items to achieve correct last items stretching */}
                        <div className="tile dummy-tile" />
                        <div className="tile dummy-tile" />
                        <div className="tile dummy-tile" />
                    </div>
                    {maxShow < total && (
                        <Button
                            text={showAll}
                            theme="secondary"
                            className="tile-grid__show-more"
                            isFullWidth
                            onClick={this.handleAddMore}
                            data-testid="showmore-button"
                        />
                    )}
                </div>
            </section>
        );
    }
}
